import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import SideMenu from './SideMenu/SideMenu';
import { SubNavProvider } from '../context/SubNavContext';
import PageErrorBoundary from '../components/PageErrorBoundary';

// Las secciones de una ficha (/agentes/12/canales) comparten la misma pantalla: cambiar de sección no la vuelve a montar ni a cargar.
const screenKey = (path) => (path.startsWith('/agentes/') ? path.split('/').slice(0, 3).join('/') : path);

const MainLayout = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [sideMenuOpen, setSideMenuOpen] = useState(true);
  const [title, setTitle] = useState('');
  const location = useLocation();

  useEffect(() => {
    const check = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      setSideMenuOpen(!mobile);
    };
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const toggleSideMenu = () => setSideMenuOpen((prev) => !prev);

  return (
    <SubNavProvider>
    {/* overflow-clip (no hidden): un contenedor «hidden» igual se puede desplazar por código (al enfocar un campo, por ejemplo) y dejaba el pie a media pantalla con un hueco vacío debajo; «clip» no se desplaza nunca. Solo scrollea <main>. */}
    <div className="flex h-screen bg-ink text-fg overflow-clip">
      <a href="#contenido" className="sr-only focus:not-sr-only focus:fixed focus:z-[60] focus:top-3 focus:left-3 focus:rounded-full focus:bg-fg focus:text-ink focus:px-4 focus:py-2 focus:text-sm">Saltar al contenido</a>
      <SideMenu isOpen={sideMenuOpen} isMobile={isMobile} toggleSideMenu={toggleSideMenu} setTitle={setTitle} />

      <div className={`flex flex-col flex-1 min-w-0 min-h-0 transition-[margin] duration-300 overflow-clip ${sideMenuOpen && !isMobile ? 'md:ml-[248px]' : 'ml-0'}`}>
        <Header title={title} menuOpen={sideMenuOpen} onToggleMenu={toggleSideMenu} />
        <main id="contenido" tabIndex={-1} className="flex-1 min-h-0 overflow-y-auto bg-ink p-4 sm:p-6 lg:p-8 focus:outline-none">
          <AnimatePresence mode="wait">
            <motion.div
              key={screenKey(location.pathname)}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.22, ease: [0.16, 1, 0.3, 1] }}
              style={{ minHeight: '100%' }}
              className="mx-auto w-full max-w-7xl"
            >
              <PageErrorBoundary resetKey={location.pathname}><Outlet /></PageErrorBoundary>
            </motion.div>
          </AnimatePresence>
        </main>
        <Footer />
      </div>
    </div>
    </SubNavProvider>
  );
};

export default MainLayout;
